import { Autocomplete, TextField } from "@mui/material";
import { useState, useEffect, useContext } from "react";
import { AppContext } from "../../../../common/contexts/app_context/app_context";

/**
 * CustomAutocomplete
 */

type Props<T extends {}> = {
  label?: string,
  value?: T | null,
  options: T[],
  required?: boolean,
  placeholder?: string,
  readOnly?: boolean,
  getOptionLabel: (opt: T) => any,
  getOptionKey: (opt: T) => any,
  onChange: (newValue: T | null) => void,
};

export const CustomAutocomplete = <T extends {},>({
  label,
  value,
  options,
  required,
  placeholder,
  readOnly,
  getOptionLabel,
  getOptionKey,
  onChange,
}: Props<T>) => {
  const mode = useContext(AppContext).theme
  const [shrink, setShrink] = useState<boolean | undefined>();

  useEffect(() => {
    const shrinkValue = (value === undefined || value === null) && (placeholder !== undefined && placeholder !== null);
    setShrink(shrinkValue ? true : undefined);
  }, [value, placeholder]);

  return (
    <Autocomplete
      size="small"
      autoHighlight={true}
      getOptionLabel={(opt) => getOptionLabel(opt)}
      getOptionKey={(opt) => getOptionKey(opt)}
      options={options}
      value={value ?? null}
      disablePortal={false}
      disableClearable={false}
      sx={{
        ".MuiInputBase-root.MuiOutlinedInput-root": {
          padding: '.05rem 1.2rem .05rem 0rem'
        },
        ".MuiOutlinedInput-input": {
          fontSize: 16,
        },
        ".MuiAutocomplete-endAdornment": {
          right: 0,
          "& .MuiSvgIcon-root": {
            fill: mode === 'dark' ? 'white' : 'black',
          },
        },
        ".MuiSvgIcon-root": {
          fontSize: 16,
        },
      }}
      onChange={(_, newValue) => {
        if (!readOnly) onChange?.(newValue);
      }}
      slotProps={{
        paper: {
          style: {
            minWidth: '20rem',
          }
        }
      }}
      readOnly={readOnly}
      renderInput={(params) => {
        return (
          <TextField {...params}
            size="small"
            label={label}
            slotProps={{
              inputLabel: {
                shrink,
              },
            }}
            required={required}
            placeholder={placeholder} />
        );
      }}
    />
  );
}